module.exports = __webpack_public_path__ + "static/media/back-effect.45a4afcb.png";